export default __webpack_public_path__ + "static/media/partner-call.2b8f9ce7.mp3";